import { makeAPICall } from "../../utils/common";
import config from "../../utils/config";

export const GET_ESTEL_LEDGER_TRANSACTION_TYPE_API = "GET_ESTEL_LEDGER_TRANSACTION_TYPE_API";
export const GET_ESTEL_LEDGER_TRANSACTION_TYPE_API_SUCCESS = "GET_ESTEL_LEDGER_TRANSACTION_TYPE_API_SUCCESS";
export const GET_ESTEL_LEDGER_TRANSACTION_TYPE_API_FAILED = "GET_ESTEL_LEDGER_TRANSACTION_TYPE_API_FAILED";

export const GET_ESTEL_LEDGER_DASHBOARD_API = "GET_ESTEL_LEDGER_DASHBOARD_API";
export const GET_ESTEL_LEDGER_DASHBOARD_API_SUCCESS = "GET_ESTEL_LEDGER_DASHBOARD_API_SUCCESS";
export const GET_ESTEL_LEDGER_DASHBOARD_API_FAILED = "GET_ESTEL_LEDGER_DASHBOARD_API_FAILED";

export function triggerEstelLedgerTransactionTypeAPI(obj) {
  return dispatch => {
    const params = {
      url: `${config.apiBasePath.baseIp}estelLedgerTransactionType`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_ESTEL_LEDGER_TRANSACTION_TYPE_API,
      successAction: GET_ESTEL_LEDGER_TRANSACTION_TYPE_API_SUCCESS,
      failedAction: GET_ESTEL_LEDGER_TRANSACTION_TYPE_API_FAILED,
      type: "POST",
      callback: obj.callback,
      extraData: obj.extraData
    }
    makeAPICall(params);
  }
}

export function triggerEstelLedgerDashboardAPI(obj) {
  return dispatch => {
    const params = {
      url: `${config.apiBasePath.baseIp}estelLedgerDashboard`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_ESTEL_LEDGER_DASHBOARD_API,
      successAction: GET_ESTEL_LEDGER_DASHBOARD_API_SUCCESS,
      failedAction: GET_ESTEL_LEDGER_DASHBOARD_API_FAILED,
      type: "POST",
      callback: obj.callback,
      extraData: obj.extraData
    }
    makeAPICall(params);
  }
}